import React from 'react';
import './ConfirmModal.css';

const ConfirmModal = ({ isOpen, title, message, onConfirm, onCancel, confirmText = 'Confirmar', cancelText = 'Cancelar', type = 'danger' }) => {
  if (!isOpen) return null;

  return (
    <div className="confirm-overlay" data-testid="confirm-modal">
      <div className="confirm-content">
        <div className="confirm-header">
          <div className={`confirm-icon ${type}`}>
            {type === 'danger' ? '⚠️' : type === 'warning' ? '⚡' : 'ℹ️'}
          </div>
          <h3 className="confirm-title">{title}</h3>
        </div>
        
        <div className="confirm-body">
          <p className="confirm-message">{message}</p>
        </div>
        
        <div className="confirm-actions">
          <button 
            onClick={onCancel} 
            className="confirm-btn-cancel"
            data-testid="confirm-cancel"
          >
            {cancelText}
          </button>
          <button 
            onClick={onConfirm} 
            className={`confirm-btn-confirm ${type}`}
            data-testid="confirm-submit"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;